import { makeStyles } from "tss-react/mui"
import { Grid } from "@mui/material"
import { DateTime } from "luxon"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { FormikSwitch, FormikTextField, FormikTimePicker } from "../../../../../shared/components/forms/Formik"
import { CreateOrEditDeliveryLocationFormValues } from "../deliveryLocationsTypes"
import { StandardForm } from "../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../shared/components/forms/StandardMainPanel"
import { StandardSidePanel } from "../../../../../shared/components/forms/StandardSidePanel"

export const FormDeliveryLocationContent = () => (
    <StandardForm>
        <StandardMainPanel>
            <LocalizedStrict id="merchant-delivery-location-form-field-name" attrs={{ label: true }}>
                <FormikTextField<CreateOrEditDeliveryLocationFormValues> name="name" label="Name *" fullWidth />
            </LocalizedStrict>
            <Grid container item gap={2} sm={12} direction="row">
                <Grid item sm={3}>
                    <LocalizedStrict id="merchant-delivery-location-form-start-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<CreateOrEditDeliveryLocationFormValues, DateTime>
                            label="From time"
                            name="timeIntervalStart"
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item sm={3}>
                    <LocalizedStrict id="merchant-delivery-location-form-end-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<CreateOrEditDeliveryLocationFormValues, DateTime>
                            label="End time"
                            name="timeIntervalEnd"
                        />
                    </LocalizedStrict>
                </Grid>
            </Grid>
        </StandardMainPanel>
        <LocalizedStrict id="merchant-delivery-location-form-settings" attrs={{ title: true }}>
            <StandardSidePanel variant="collapsible" title="Settings">
                <LocalizedStrict id="merchant-delivery-location-form-field-active">
                    <FormikSwitch<CreateOrEditDeliveryLocationFormValues> name="isActive">Active:</FormikSwitch>
                </LocalizedStrict>
            </StandardSidePanel>
        </LocalizedStrict>
    </StandardForm>
)
